import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import PurchaseOrderService from "../../Controller/PurchaseOrderController";
import CountryService from "../../../Setup/controller/CountryController/CountryController";
import { handleChange, handleSubmit } from "../../Controller/UpdateCustomerAddressController";
import HelpSite from "../../../Common/HelpLink";
function PurchaseOrderAddress({ PurchaseOrderID }) {
    const navigate = useNavigate();
    const location = useLocation();
    const [errors, setErrors] = useState({});
    const [CountryList, setCountries] = useState([]);
    const [formData, setFormData] = useState({
        cust_FullName: "",
        cust_Address1: "",
        cust_Address2: "",
        cust_Address3: "",
        cust_Town: "",
        cust_County: "",
        cust_Country: "",
        cust_Telephone: "",
        cust_PostCode: ""
    });
    const { theme } = useContext(ThemeContext);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }

    useEffect(() => {
        fetchCountries();
        if (PurchaseOrderID > 0) {
            fetchPurchaseOrderDetail();
        }
        else {
            resetForm();
        }
    }, [PurchaseOrderID]);
    const fetchCountries = async () => {
        try {
            const listOfCountries = await CountryService.GetAllCountries();
            setCountries(listOfCountries);
        } catch (error) {
            console.error('Error fetching countries:', error);
        }
    };
    const fetchPurchaseOrderDetail = async () => {
        try {
            const redirectCallback = () => navigate('/');

            if (PurchaseOrderID > 0) {
                const purchaseOrderDetail = await PurchaseOrderService.GetPurchaseOrderByID(redirectCallback, PurchaseOrderID);
                const purchaseOrder = purchaseOrderDetail[0];
                setFormData({
                    ...purchaseOrder,
                });
            }
        } catch (error) {
            console.error('Error fetching agreement details:', error);
        }
    };
    const handleFormSubmit = async (event) => {
        event.preventDefault();

        try {
            const redirectUserList = () => {
                navigate('/PurchasingList?saved=true');
            };
            const message = await handleSubmit(event, formData, setFormData, setErrors);
            if (message == "Data saved successfully") {
                setShowSuccessMessage(true);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setTimeout(() => {
                    setShowSuccessMessage(false);
                }, 5000);
            }
            else {
                setShowErrorMessage(true);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setTimeout(() => {
                    setShowErrorMessage(false);
                }, 5000);

            }
            fetchPurchaseOrderDetail();
        } catch (error) {
            console.error('Error submitting form:', error);
            setErrors({ submit: 'An error occurred while submitting the form. Please try again.' });
        }
    };
    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };
    const resetForm = () => {

        setFormData({
            cust_FullName: "",
            cust_Address1: "",
            cust_Address2: "",
            cust_Address3: "",
            cust_Town: "",
            cust_County: "",
            cust_Country: "",
            cust_Telephone: "",
            cust_PostCode: ""
        });
    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            {showSuccessMessage && (
                <div class="alert alert-success bg-success text-light border-0 alert-dismissible fade show" role="alert">
                    Data saved successfully.
                </div>
            )}
            {showErrorMessage && (
                <div class="alert alert-danger bg-danger text-light border-0 alert-dismissible fade show" role="alert">
                    Validation Error.

                </div>
            )}
            <div className="row mb-3" style={{ "marginLeft": "0px" }}>
                <div className="col-xl-12" style={{ "textAlign": "right" }}>

                </div>
            </div>
            <form onSubmit={handleFormSubmit}>
                <div className="row mb-3" style={{ marginRight: "5px", marginTop: "10px" }}>
                    <table style={{ width: "100%" }}>
                        <tbody>


                            <tr>
                                <td style={{width:"13%"}}><label htmlFor="cust_CompanyName" style={{ float: "right" }}>Company <span style={{ "color": "red" }}>*</span></label></td>
                                <td style={{width:"37%"}}>
                                    <input type="text" className="form-control" name="cust_CompanyName" value={formData.cust_CompanyName} onChange={handleFieldChange} />
                                    {errors.cust_CompanyName && <div style={{ color: 'red' }}>{errors.cust_CompanyName}</div>}
                                </td>
                                <td style={{width:"13%"}}><label htmlFor="cust_FullName" style={{ float: "right" }}>Name <span style={{ "color": "red" }}>*</span></label></td>
                                <td style={{width:"37%"}}>
                                    <input type="text" className="form-control" name="cust_FullName" value={formData.cust_FullName} onChange={handleFieldChange} />
                                    {errors.cust_FullName && <div style={{ color: 'red' }}>{errors.cust_FullName}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="cust_Address1" style={{ float: "right" }}>Address <span style={{ "color": "red" }}>*</span></label></td>
                                <td colSpan={3}>
                                    <input type="text" className="form-control" name="cust_Address1" value={formData.cust_Address1} onChange={handleFieldChange} />
                                    {errors.cust_Address1 && <div style={{ color: 'red' }}>{errors.cust_Address1}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="cust_Address2" style={{ float: "right" }}></label></td>
                                <td colSpan={3}>
                                    <input type="text" className="form-control" name="cust_Address2" value={formData.cust_Address2} onChange={handleFieldChange} />
                                    {errors.cust_Address2 && <div style={{ color: 'red' }}>{errors.cust_Address2}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="cust_Address3" style={{ float: "right" }}></label></td>
                                <td colSpan={3}>
                                    <input type="text" className="form-control" name="cust_Address3" value={formData.cust_Address3} onChange={handleFieldChange} />
                                    {errors.cust_Address3 && <div style={{ color: 'red' }}>{errors.cust_Address3}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="cust_Town" style={{ float: "right" }}>Town <span style={{ "color": "red" }}>*</span></label></td>
                                <td>
                                    <input type="text" className="form-control" name="cust_Town" value={formData.cust_Town} onChange={handleFieldChange} />
                                    {errors.cust_Town && <div style={{ color: 'red' }}>{errors.cust_Town}</div>}
                                </td>
                                <td><label htmlFor="cust_County" style={{ float: "right" }}>County <span style={{ "color": "red" }}>*</span></label></td>
                                <td>
                                    <input type="text" className="form-control" name="cust_County" value={formData.cust_County} onChange={handleFieldChange} />
                                    {errors.cust_County && <div style={{ color: 'red' }}>{errors.cust_County}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="cust_PostCode" style={{ float: "right" }}>Post Code <span style={{ "color": "red" }}>*</span></label></td>
                                <td>
                                    <input type="text" className="form-control" name="cust_PostCode" value={formData.cust_PostCode} onChange={handleFieldChange} />
                                    {errors.cust_PostCode && <div style={{ color: 'red' }}>{errors.cust_PostCode}</div>}
                                </td>
                                <td><label htmlFor="cust_Telephone" style={{ float: "right" }}>Telephone <span style={{ "color": "red" }}>*</span></label></td>
                                <td>
                                    <input type="text" className="form-control" name="cust_Telephone" value={formData.cust_Telephone} onChange={handleFieldChange} />
                                    {errors.cust_Telephone && <div style={{ color: 'red' }}>{errors.cust_Telephone}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="cust_Country" style={{ float: "right" }}>Country <span style={{ "color": "red" }}>*</span></label></td>
                                <td>
                                    <select name="cust_Country" className='form-control' value={formData.cust_Country} onChange={handleFieldChange}>
                                        <option value="0">Select Country</option>
                                        {CountryList.map((country) => (
                                            <option key={country.PK_Country_ID} value={country.PK_Country_ID}>
                                                {country.vc_CountryName}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.vc_Country && <div style={{ color: 'red' }}>{errors.vc_Country}</div>}
                                </td>

                            </tr>
                           <tr>
                                <td colSpan={3}></td>
                                <td style={{ float: "right" }}>
                                    <button type="submit" className={`btn btn-primary ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`}>
                                        <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} /> Save
                                    </button>

                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </form>


        </div>


    );
}
export default PurchaseOrderAddress;

